import classNames from "classnames";
import { Typography } from "@/components/kit";
import { ReactNode, useMemo } from "react";
import { TTypographyProps } from "@/components/kit/Typography";

export type TBadgeProps = Readonly<{
  children: ReactNode;
  size?: "xs" | "sm" | "md" | "lg" | "xl";
  state?: "info" | "success" | "warning" | "notice" | "pause" | "danger" | "";
  className?: string;
  typographyClassName?: string;
  textColor?: string;
}>;
const Index = (props: TBadgeProps) => {
  const {
    size = "md",
    children,
    state = "success",
    textColor,
    className,
    typographyClassName,
  } = props;

  const typographyVariant = useMemo<TTypographyProps["variant"]>(() => {
    type TData = {
      [key in TBadgeProps["size"] as keyof TBadgeProps["size"]]: TTypographyProps["variant"];
    };
    const data: TData = {
      xs: "Caption2-Regular",
      sm: "Caption1-Regular",
      md: "Body2-Regular",
      lg: "Button2",
      xl: "Button2",
    };
    return data[size as keyof TBadgeProps["size"]];
  }, [size]);

  return (
    <div
      className={classNames(
        "rounded-md flex items-center py-1 px-2 gap-x-1 w-min whitespace-nowrap h-fit",
        {
          "bg-yellow-50 text-yellow-600 fill-yellow-600": state === "warning",
          "bg-green-50 text-green-600 fill-green-600": state === "success",
          "bg-blue-50 text-blue-600 fill-blue-600": state === "info",
          "bg-gray-100 text-gray-600 fill-gray-600": state === "notice",
          "bg-yellow-50 text-orange-600 fill-orange-600": state === "pause",
          "bg-red-50 text-red-600 fill-red-600": state === "danger",
          "!py-2": size === "md",
          "!py-[10px]": size === "lg",
          "!py-3": size === "xl",
        },
        className,
      )}
    >
      <Typography
        variant={typographyVariant}
        className={classNames(
          "w-full",
          {
            "!text-orange-600": state === "warning" || state === "pause",
            "!text-green-600": state === "success",
            "!text-blue-600": state === "info",
            "!text-gray-600": state === "notice",
            "!text-red-600": state === "danger",
          },
          typographyClassName,
        )}
        color={textColor}
      >
        {children}
      </Typography>
    </div>
  );
};

export default Index;
